import React, { useCallback } from 'react';
import { faClock } from '@fortawesome/pro-solid-svg-icons/faClock';
import { faXmarkCircle } from '@fortawesome/pro-solid-svg-icons/faXmarkCircle';
import { faCheckCircle } from '@fortawesome/pro-solid-svg-icons/faCheckCircle';
import { faCircleDashed } from '@fortawesome/pro-solid-svg-icons/faCircleDashed';

import { EnhancedReturnStatus } from '../../../../enums/enhanced-return-status';
import { useSalesOrderIdContext } from '../../../context/sales-order-id-context-provider';
import { useReturnNavigation } from '../../hooks/use-return-navigation';
import { NavigationButton } from '../navigation-panel/navigation-button';
import { useCanCreateEnhancedReturn } from '../../../../store/returns/returns.helpers';
import { useReturnIdContext } from '../../context/return-id-context-provider';
import { RETURN_SIDEBAR_CLICKED } from '../../../../constants/analytics-events';
import { Segment } from '../../../../services/analytics-services/segment';

import style from './enhanced-returns-panel-button.module.less';

const defaultIcon = {
  icon: faCircleDashed,
  iconClassName: style['default-icon'],
};

const statusToIconMap = {
  [EnhancedReturnStatus.PendingCompletion.key]: defaultIcon,
  [EnhancedReturnStatus.PendingAtAdmin.key]: {
    icon: faClock,
    iconClassName: style['pending-icon'],
  },
  [EnhancedReturnStatus.PendingAtStore.key]: {
    icon: faClock,
    iconClassName: style['pending-icon'],
  },
  [EnhancedReturnStatus.PendingAtWarehouse.key]: {
    icon: faClock,
    iconClassName: style['pending-icon'],
  },
  [EnhancedReturnStatus.PendingDelivery.key]: {
    icon: faClock,
    iconClassName: style['pending-icon'],
  },
  [EnhancedReturnStatus.PendingPaymentCompletion.key]: {
    icon: faClock,
    iconClassName: style['pending-icon'],
  },
  [EnhancedReturnStatus.Cancelled.key]: {
    icon: faXmarkCircle,
    iconClassName: style['cancelled-icon'],
  },
  [EnhancedReturnStatus.Processed.key]: {
    icon: faCheckCircle,
    iconClassName: style['processed-icon'],
  },
};

export const EnhancedReturnsPanelButton = ({ name, returnRequestId, status }) => {
  const salesOrderId = useSalesOrderIdContext();
  const shouldUseEnhancedReturn = useCanCreateEnhancedReturn(salesOrderId);
  const selectedReturnId = useReturnIdContext();
  const isSelected = !!selectedReturnId && selectedReturnId === returnRequestId;
  const { icon, iconClassName } = statusToIconMap[status] || defaultIcon;

  const { navigateToReturn } = useReturnNavigation();

  const navigateTo = useCallback(() => {
    Segment.trackEvent(RETURN_SIDEBAR_CLICKED, {
      type: RETURN_SIDEBAR_CLICKED,
      enhanced: true,
      requestId: returnRequestId,
      salesOrderId,
    });

    navigateToReturn(salesOrderId, returnRequestId, shouldUseEnhancedReturn);
  }, [navigateToReturn, returnRequestId, salesOrderId, shouldUseEnhancedReturn]);

  return (
    <NavigationButton icon={icon} iconClassName={iconClassName} isSelected={isSelected} onClick={navigateTo}>
      {name}
    </NavigationButton>
  );
};
